/* ============================================
   SUVENE — Trusted Shops Rating Sync
   Liest Rating aus Floating Badge und updated Footer
   ============================================ */

(function() {
  'use strict';

  function syncRating() {
    // Rating aus Floating Badge lesen
    const ratingEl = document.querySelector('._zdslfp');
    const footerRating = document.querySelector('.su-footer-ts__rating');

    if (!ratingEl || !footerRating) return false;

    const rating = ratingEl.textContent.trim();
    if (rating && rating !== footerRating.textContent.trim()) {
      footerRating.textContent = rating;
      console.log('[Suvene] TS Rating synced:', rating);
    }
    return true;
  }

  // Warten bis Floating Badge gerendert ist (wird async geladen)
  var attempts = 0;
  var interval = setInterval(function() {
    attempts++;
    if (syncRating() || attempts > 40) {
      clearInterval(interval);
    }
  }, 500);

  // Auch bei DOM-Änderungen neu prüfen (falls Badge später eingeblendet wird)
  var observer = new MutationObserver(function() {
    syncRating();
  });

  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, { childList: true, subtree: true });
    syncRating();
  });

})();